var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "Checkbox",
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
          ) {
            return null
          }
          return _vm.onFocus.apply(null, arguments)
        }
      }
    },
    [
      _c("input", {
        staticClass: "form-control checkbox",
        attrs: { id: _vm.id, disabled: _vm.disabled, type: "checkbox" },
        domProps: { checked: _vm.checked }
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "checkmark",
        class: { disabled: _vm.disabled },
        style: { background: _vm.transparent ? "transparent" : "white" },
        on: { click: _vm.onFocus }
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "checkbox-description",
          class: { disabled: _vm.disabled },
          on: { click: _vm.onFocus }
        },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-531e993c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-531e993c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls/Checkbox.vue
// module id = null
// module chunks = 